import { Skeleton } from '@mui/material';
import { styled } from '@/theme/index';

export const SkeletonText = styled(Skeleton)(({ theme }) => ({
  height: '45px',
  width: '80%',
  borderRadius: '12px',
  marginBottom: theme.spacing(1.25),
}));

export const SkeletonTextTitle = styled(SkeletonText)(() => ({
  width: '90%',
  height: '40px',
}));

export const SkeletonTopHapImg = styled(Skeleton)(({ theme }) => ({
  marginTop: theme.spacing(1.5),
  borderRadius: '12px',
  border: `solid 1px ${theme.palette.grey[200]}`,
  width: '100%',
  height: '420px',
  maxWidth: '380px',
}));

export const TopHapImg = styled('img')(({ theme }) => ({
  marginTop: theme.spacing(1.5),
  borderRadius: '12px',
  border: `solid 1px ${theme.palette.grey[200]}`,
  width: '100%',
  maxWidth: '380px',
}));
